import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SvgIcon from '@mui/material/SvgIcon';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { styled } from '@classify/react-core-components/styles';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';

const ButtonStyled = styled(Button)(({ theme: { palette, spacing } }) => ({
  '&&': {
    border: `1px solid ${palette.interaction.border}`,
    backgroundColor: palette.layout.background.navigation,
    padding: spacing(4, 2),
    width: '100%',
    color: palette.text.onMain,
  },
  '& .MuiButton-startIcon + span': {
    flexGrow: 1,
    textAlign: 'left',
  },
  '& .MuiButton-startIcon .MuiSvgIcon-root': {
    width: 32,
    height: 32,
  },
  '& .MuiButton-endIcon .MuiSvgIcon-root': {
    width: 24,
    height: 24,
  },
})) as typeof Button;

interface Props {
  children: string;
  iconComponent: typeof SvgIcon;
  onClick?: () => void;
  href?: string;
}

export default function ContactChannelButton({
  children,
  iconComponent: Icon,
  onClick = () => {},
  href,
}: Props) {
  return (
    <>
      <ButtonStyled
        href={href}
        startIcon={<Icon fontSize="large" />}
        endIcon={href ? <OpenInNewIcon fontSize="large" /> : <ChevronRightIcon />}
        variant="tertiary"
        onClick={onClick}
        target="_blank"
      >
        <Typography variant="h4" component="span">
          {children}
        </Typography>
      </ButtonStyled>
    </>
  );
}
